import React from 'react';
import {connect} from 'react-redux';
import TeamLogo from 'components/molecules/team-logo';
import {LineupPlayersSketch} from 'components/organisms/lineup/components/lineup-players/sports/lol/classic';

class LineupPlayersComponent extends LineupPlayersSketch {
    render() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        if (!lineup) {
            return null;
        }

        const rows = [];
        lineup.players.map((player, index) => {
            const userPoints = player.lineupPoints;
            const salary = player.getCapPropValue('salary');
            const className = this.getStackClassNameByPlayer(player);
            const rowClassName = this.getRowClassName(player);

            rows.push(
                <tr key={player.playerId} className={rowClassName}>
                    <td>
                        <strong className={className}>{player.name}</strong>
                    </td>
                    <td>{player.positionInLineup}</td>
                    <td>
                        <TeamLogo teamName={player.team.toUpperCase()} />
                    </td>
                    <td>
                        <strong className="text-gray">{salary}</strong>/{parseFloat(userPoints).toFixed(3)}
                    </td>
                </tr>,
            );
        });

        return (
            <table className="table">
                <tbody>{rows}</tbody>
            </table>
        );
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking, lineupsData, filterLineupsByPlayer} = state;
    return {
        lineups: lineupsData.lineups,
        rawLineups: lineupsData.rawLineups,
        stacking: randomTeamStacking,
        filterLineupsByPlayer,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
